import Button from "components/Buttons/Button";
import InputField from "components/FormFields/InputField";
import { useAuth } from "hooks/useAuth";
import { http } from "middleware/apiMiddleware";
import { useState } from "react";
import { ReactComponent as Logo } from "assets/RewardsLogo.svg";
import { signIn } from "constants/apiUrls";
import { useLazyUserQuery } from "store/apis/userApi";
import { toast } from "react-hot-toast";
import { checkInputFormat } from "utils/common";
import useMixpanel from "hooks/useMixpanel";
import { routes } from "constants/routes";
export const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { trackEvent } = useMixpanel();
  const [isloggingIn, setIslogginingIn] = useState(false);
  const [fetchUser, { isFetching, isSuccess, error, isError }] =
    useLazyUserQuery();
  const authContext = useAuth();
  const payload =
    checkInputFormat(username) === "email"
      ? { email: username, password }
      : { phoneNumber: username, password };

  const handleLogin = async (e: any) => {
    try {
      trackEvent("sign_in_button_Clicking", { username });
      setIslogginingIn(true);
      e.preventDefault();
      // Here you would usually send a request to your backend to authenticate the user
      // For the sake of this example, we're using a mock authentication
      const { data, error } = await http.post(signIn, payload, false);
      if (!!data && !error) {
        const userResponse = await fetchUser({
          token: data?.access,
          uuid: data?.uuid,
        });
        if (userResponse?.isSuccess) {
          trackEvent("sign_in_success", { signInResponse: data });
          await authContext?.login(
            { data: { ...userResponse.data, ...data } },
            `${routes.chooseBusiness}/1`
          );
        }
      } else {
        trackEvent("sign_in_failure", { error, username });
        toast.error("Invalid username or password");
      }
    } catch (error) {
      trackEvent("sign_in_failure_unexpected", { error, username });
      toast.error("unexpected error occurred while login");
      setIslogginingIn(false);
    } finally {
      setIslogginingIn(false);
    }
  };
  return (
    <div className="flex gap-4 flex-col md:w-2/5 w-full">
      <div className="text-lg color-black20">Welcome to</div>
      <Logo />
      <span className="text-sm opacity-60 text-black">
        Enter your credentials to access account
      </span>
      <div>
        <form onSubmit={handleLogin}>
          <div>
            <InputField
              id="email"
              value={username}
              label={"Email Address"}
              placeholder="Enter email eddress"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div>
            <InputField
              type="password"
              id="password"
              value={password}
              label={"Password"}
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button
            label={"Sign In"}
            type="submit"
            disabled={!username || !password}
            loading={isFetching || isloggingIn}
          />
        </form>
      </div>
    </div>
  );
};

export default Login;
